import React,{useState} from 'react'
import arrowUp from '../../img/arrow-up.svg'
import arrowdown from '../../img/arrow-down.png'

const SingleAccordion = ({ title, children }) => {
    const [isOpen, setOpen] = React.useState(false);
    return (
      <div className="accordion-wrapper">
        
        <div
          className={` accordion-title ${isOpen ? "open" : ""}`}
          onClick={() => setOpen(!isOpen)}
          >
                {
            !isOpen ?
            <img src={arrowdown} />
            :
            <img src={arrowUp} />

        }
          <p>{title}</p>
      
        </div>
        <div className={`accordion-item ${!isOpen ? "collapsed" : ""}`}>
          <div className="accordion-content">{children}</div>
        </div>
      </div>
    );
  };
export default SingleAccordion
